import { isNotDefined } from '@sgme/fp';

export const roundToFixed = (value: number, precision: number) => {
  const scale = 10 ** precision;

  // it has better performance than Number(value.toFixed(precision))
  return Math.round(value * scale) / scale;
};

export function parseDecimal(value: string): number;
export function parseDecimal(value: string | null): number | null;
export function parseDecimal(value: string | null): number | null {
  if (isNotDefined(value)) {
    return null;
  }
  const parsed = Number.parseFloat(value);
  return Number.isNaN(parsed) ? 0 : parsed;
}
